import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';
import store from 'stores/RootStore';
import { DocumentType } from 'types/DocumentType';

import NavButtons from '../../Views/Animation/NavButtons';
import EditDocumentButton from '../EditDocumentButton/EditDocumentButton';
import NavBreadcrumb from '../NavBreadcrumb/NavBreadcrumb';
import Spacer from '../Spacer/Spacer';
import { Container } from './NavHeader.styles';

const DocumentTypeNameContainer = styled.div`
  display: flex;
  background: #01152a;
  height: 39px;
  padding: 13px;
  align-items: center;
  margin-right: 20px;
  border-radius: 6px;
  color: white;
  font-size: 19px;
  font-weight: 600;
`;

function titleCase(documentTypeName: string): string {
  return documentTypeName.charAt(0).toUpperCase() + documentTypeName.slice(1);
}

function documentTypeLabelForName(currentDocument_type: string) {
  switch (currentDocument_type) {
    case 'document':
      return '';
    case 'dynamic':
      return 'Creative';
    default:
      return titleCase(currentDocument_type);
  }
}

function NavHeader() {
  // Collect references to global app state up here for potential
  // decouple/props refactoring
  const store_animation = store.animation;
  const currentDocument = store.current;
  const store_documentType = store.documentType;
  const store_animationPreview = store.preview;
  const store_ui = store.ui;

  // Separate out store.* accesses that are only ever used once:
  // to access a further nested property
  const userIsAuthenticated = store.user.authenticated;
  const currentRoute = store.router.currentRoute;

  const currentDocumentWithMembers =
    currentDocument instanceof DocumentWithMembershipStore
      ? (currentDocument as DocumentWithMembershipStore)
      : null;

  const currentDocumentIsEditable = currentDocumentWithMembers?.canEdit;

  const showBreadcrumbs = store_ui.areBreadcrumbsVisible;
  const isMobile = store_ui.isMobile;

  const breadcrumbs = currentDocument?.breadcrumbs;
  const hasBreadcrumbs = breadcrumbs ? breadcrumbs.all.length > 0 : false;

  const isPreview = !!(userIsAuthenticated && store_animationPreview?.mounted);

  const documentTypeName = isPreview
    ? 'Preview'
    : currentDocument
      ? documentTypeLabelForName(currentDocument.type)
      : '';

  const showSelf = hasBreadcrumbs || documentTypeName || isPreview;

  const showEditDocumentButton =
    !isMobile && hasBreadcrumbs && currentDocumentIsEditable && currentRoute;

  const showAnimationNavButtons =
    !isMobile &&
    store_documentType === DocumentType.ANIMATION &&
    store_animation &&
    currentDocumentIsEditable &&
    currentRoute;

  return (
    <Container
      className={store_ui.collapsed ? 'collapsed' : ''}
      style={showSelf ? {} : { display: 'none' }}
    >
      {documentTypeName && (
        <DocumentTypeNameContainer>
          {documentTypeName}
        </DocumentTypeNameContainer>
      )}
      {showBreadcrumbs && breadcrumbs && (
        <NavBreadcrumb breadcrumbs={breadcrumbs} />
      )}
      {showEditDocumentButton && <EditDocumentButton />}
      {showAnimationNavButtons && <NavButtons />}
      <Spacer />
    </Container>
  );
}

export default observer(NavHeader);
